var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styleObjGdWrapper)},[_c('el-amap',{ref:"map",attrs:{"vid":"amapDemo","amap-manager":_vm.amapManager,"center":_vm.mapCenter,"zoom":_vm.zoom,"events":_vm.events}},_vm._l((_vm.markers),function(marker,index){return _c('el-amap-marker',{key:index,attrs:{"position":marker.position,"events":marker.events}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }